import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { NavLink } from 'react-router-dom';

const SmallScreenLink = ({ to, label, className, onClick, disabled }) => {
  const clickFunc = evt => {
    evt.stopPropagation();
    onClick();
  };
  return (
    <li className={classnames(className, 'text-color-secondary')}>
      {disabled ? (
        <div
          className={`
bg-secondary-grey border-bottom d-sm-b prl5-sm pt4-sm pb4-sm text-color-warm-grey text-color-accent`}
          data-desc={`smallScreen__link_${to}`}
        >
          {label}
        </div>
      ) : (
        <NavLink
          to={to}
          onClick={clickFunc}
          className='bg-secondary-grey border-bottom d-sm-b prl5-sm pt4-sm pb4-sm text-color-accent'
          data-desc={`smallScreen__link_${to}`}
          exact
        >
          {label}
        </NavLink>
      )}
    </li>
  );
};

SmallScreenLink.defaultProps = {
  className: '',
  disabled: false
};

SmallScreenLink.propTypes = {
  className: PropTypes.string,
  label: PropTypes.any.isRequired,
  to: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default SmallScreenLink;
